<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="modal fade"
        id="displayPin2"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              v-on:click="closeDisplayPin2Modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>

            <div class="modal-body">
              <p>
                <strong
                  >Pass code sent to your phone number<br />registered for this
                  card vis SMS</strong
                >
              </p>
              <p>
                Registered Phone number<br /><span class="regNo"
                  ><strong>xxxxxxx{{ lastFourPhoneDigits }}</strong></span
                >
              </p>

              <div class="loginControls regNo">
                <form action="form" @submit.prevent="postSmsConfirmationCode">
                  <input
                    id="digit1"
                    type="text"
                    maxlength="1"
                    v-model="digit1"
                    @keypress="onlyNumber"
                  />
                  <input
                    id="digit2"
                    type="text"
                    maxlength="1"
                    v-model="digit2"
                    @keypress="onlyNumber"
                  />
                  <input
                    id="digit3"
                    type="text"
                    maxlength="1"
                    v-model="digit3"
                    @keypress="onlyNumber"
                  />
                  <input
                    id="digit4"
                    type="text"
                    maxlength="1"
                    v-model="digit4"
                    @keypress="onlyNumber"
                  />
                  <input
                    id="digit5"
                    type="text"
                    maxlength="1"
                    v-model="digit5"
                    @keypress="onlyNumber"
                  />
                  <input
                    id="digit6"
                    type="text"
                    maxlength="1"
                    v-model="digit6"
                    @keypress="onlyNumber"
                  />

                  <p class="remaining">
                    If you couldn't receive the SMS within 5 minutes you can try
                    again
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>All Transactions</h2>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>
        <div class="transFilter profile">
          <form action="form" @submit.prevent="getAllTransactions">
            <div class="row">
              <div class="col-md-3" style="padding-right: 9px">
                <input
                  type="date"
                  id="fromdate"
                  name="fromdate"
                  placeholder="dd/mm/yyyy"
                  v-model="dateFrom"
                />
              </div>
              <div
                class="col-md-3"
                style="padding-left: 9px; padding-right: 9px"
              >
                <input
                  type="date"
                  id="todate"
                  name="todate"
                  placeholder="dd/mm/yyyy"
                  v-model="dateTo"
                />
              </div>
              <div
                class="col-md-5"
                style="padding-left: 9px; padding-right: 9px"
              >
                <input
                  type="text"
                  id="keyword"
                  name="keyword"
                  placeholder="Keyword"
                />
              </div>
              <div class="col-md-1" style="padding-left: 9px">
                <button type="submit" class="btn-submit"></button>
              </div>
            </div>
          </form>
        </div>
        <div class="tablesurround">
          <table width="100%" border="0">
            <tbody>
              <tr class="thead">
                <th
                  scope="col"
                  width="55px;"
                  class="colAmt"
                  style="text-align: left; padding-left: 10px"
                >
                  Amount
                </th>
                <th
                  scope="col"
                  width="40px;"
                  class="colDate"
                  style="text-align: center; text-indent: -10px"
                >
                  Date
                </th>
                <th
                  scope="col"
                  width="392px;"
                  class="colTrans"
                  style="text-align: left; text-indent: -5px"
                >
                  Transaction details
                </th>
                <th
                  scope="col"
                  width="121px;"
                  class="colBal"
                  style="text-align: right; padding-right: 30px"
                >
                  Balance
                </th>
              </tr>
            </tbody>
          </table>
          <div
            v-if="isAllTransactionsGridLoading === true"
            class="tablesurroundinner"
          >
            <div class="d-flex justify-content-center" style="margin-top: 10px">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div
            v-if="isAllTransactionsGridLoading === false"
            class="tablesurroundinner"
          >
            <table width="100%" border="0">
              <tbody
                v-for="transaction of transactionStatement.transactions"
                :key="transaction.id"
              >
                <tr>
                  <td class="colAmt">
                    <span class="amt">{{
                      "-" +
                        transaction.currency +
                        transaction.amountInCardCurrency.toFixed(2)
                    }}</span>
                    <span class="time">{{ transaction.timeDisplay }}</span>
                  </td>
                  <td class="colDate">
                    <div class="date">
                      <span class="datenum">{{ transaction.dayDisplay }}</span
                      ><span class="dateday">{{
                        transaction.dayOfWeekDisplay
                      }}</span>
                    </div>
                  </td>
                  <td class="colTrans">
                    <div class="transText">
                      {{ transaction.description }}
                    </div>
                    <div class="transLabels">
                      <span class="transLabel">{{
                        transaction.typeDisplay
                      }}</span>
                      <span
                        class="transLabel"
                        v-if="transaction.feeInCardCurrency > 0"
                        >{{ transaction.feeDisplay }}</span
                      >
                    </div>
                  </td>
                  <td class="colBal current">
                    <span class="figures"
                      ><strong></strong> £{{
                        transaction.balance.toFixed(2)
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
              <tbody
                v-if="
                  transactionStatement.transactions !== undefined &&
                    transactionStatement.transactions !== null &&
                    transactionStatement.transactions.length === 0
                "
              >
                <td
                  style="
                    display: flex;
                    justify-content: center;
                    margin-top: 11px;
                  "
                >
                  No transactions to display
                </td>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tablesurround mobtable">
          <table width="100%" border="0">
            <tbody>
              <tr class="thead">
                <th
                  scope="col"
                  width="55px;"
                  class="colAmt"
                  style="text-align: left; padding-left: 10px"
                >
                  Amount
                </th>
                <th
                  scope="col"
                  width="40px;"
                  class="colDate"
                  style="text-align: center; text-indent: -10px"
                >
                  Date
                </th>
                <th
                  scope="col"
                  width="121px;"
                  class="colBal"
                  style="text-align: right; padding-right: 30px"
                >
                  Balance
                </th>
              </tr>
            </tbody>
          </table>

          <template
            v-if="
              isAllTransactionsGridLoading == false &&
                transactionStatement.transactions != undefined &&
                transactionStatement.transactions != null &&
                transactionStatement.transactions.length > 0
            "
          >
            <div
              v-for="transaction of transactionStatement.transactions"
              v-bind:key="transaction.id"
              class="tablesurroundinner"
            >
              <table width="100%" border="0">
                <tbody>
                  <tr>
                    <td class="colAmt">
                      <span class="amt">{{
                        "-" +
                          transaction.currency +
                          transaction.amountInCardCurrency.toFixed(2)
                      }}</span>
                      <span class="time">{{ transaction.timeDisplay }}</span>
                    </td>
                    <td class="colDate">
                      <div class="date">
                        <span class="datenum">{{ transaction.dayDisplay }}</span
                        ><span class="dateday">{{
                          transaction.dayOfWeekDisplay
                        }}</span>
                      </div>
                    </td>
                    <td class="colBal current">
                      <span class="figures"
                        ><strong></strong> £{{
                          transaction.balance.toFixed(2)
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="transText">
                {{ transaction.description }}
              </div>
              <div class="transLabels">
                <span class="transLabel">{{ transaction.typeDisplay }}</span>
                <span
                  class="transLabel"
                  v-if="transaction.feeInCardCurrency > 0"
                  >{{ transaction.feeDisplay }}</span
                >
              </div>
            </div>
          </template>
          <template
            v-if="
              (isAllTransactionsGridLoading == false &&
                transactionStatement.transactions == null) ||
                (isAllTransactionsGridLoading == false &&
                  transactionStatement.transactions.length == 0)
            "
          >
            <div class="tablesurroundinner">
              <table width="100%" border="0">
                <tbody>
                  <td
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 11px;
                    "
                  >
                    No transactions to display
                  </td>
                </tbody>
              </table>
            </div>
          </template>
          <template>
            <div
              v-if="isAllTransactionsGridLoading == true"
              class="tablesurroundinner"
              style="padding-top: 10px"
            >
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="spacer-60"></div>
      </div>

      <div v-if="isCmsUsed === false" class="col-md-3 promos">
        <h2>Promotions</h2>
        <a href="#" class="promo"
          ><img
            src="assets/images/Piaggio-HQ-Banners-Promotions-MP3-GameChanger.png"
            width="864"
            height="453"
            alt=""
          />
        </a>
        <a href="#" class="promo"
          ><img
            src="assets/images/NoPath - Copy.png"
            width="864"
            height="453"
            alt=""
        /></a>
      </div>

      <div
        v-if="isCmsUsed === true"
        class="col-md-3 promos"
        v-html="rightContent"
      ></div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import $ from "jquery";
import Cards from "./Cards.vue";
import actions from "@/store/cards/actions";
import configuration from "@/services/config";
export default {
  components: {
    Cards
  },
  created() {
    this.rightContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.rightContent != null
        ? this.cmsPage.rightContent
        : "";
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
  },
  data() {
    return {
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
      digit5: "",
      digit6: ""
    };
  },
  beforeMount() {
    this.isAllTransactionsGridLoading = true;
    const fetchTransactionsCriteria = {
      CardGuid: this.cardGuid
    };
    this.$store.dispatch(
      actions.FETCH_ALL_TRANSACTIONS,
      fetchTransactionsCriteria
    );
  },
  mounted() {
    const displayPin2Modal = $("#displayPin2");
    const closeDisplayPin2ModalJquery = this.closeDisplayPin2Modal;

    displayPin2Modal.click(function(event) {
      if (event.target == this) {
        closeDisplayPin2ModalJquery();
      }
    });
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    dateFrom: {
      get() {
        return this.$store.state.cards.dateFrom;
      },
      set(value) {
        this.$store.commit("updateDateFromMutation", value);
      }
    },
    dateTo: {
      get() {
        return this.$store.state.cards.dateTo;
      },
      set(value) {
        this.$store.commit("updateDateToMutation", value);
      }
    },
    cardGuid: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.cardGuid;
      }
    },
    lastFourPhoneDigits: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.phone.slice(
          this.$store.state.accounts.fullAccountDetails.user?.phone.length - 4
        );
      }
    },
    transactionStatement: {
      get() {
        return this.$store.state.cards.transactionStatement;
      }
    },
    requiredSmsCode: {
      get() {
        return this.$store.state.cards.transactionStatement.requiredSmsCode;
      },
      set(value) {
        this.$store.commit("updateIsRequiredSmsCodeMutation", value);
      }
    },
    isAllTransactionsGridLoading: {
      get() {
        return this.$store.state.settings.isAllTransactionsGridLoading;
      },
      set(value) {
        this.$store.commit("updateIsAllTransactionsGridLoadingMutation", value);
      }
    }
  },
  methods: {
    onlyNumber: function($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const symbol = String.fromCharCode(keyCode);

      if (/^\s*$/.test(symbol) || isNaN(symbol)) {
        $event.preventDefault();
      } else {
        const inputId = $event.target.id;

        switch (inputId) {
          case "digit1":
            this.digit1 = symbol;
            break;
          case "digit2":
            this.digit2 = symbol;
            break;
          case "digit3":
            this.digit3 = symbol;
            break;
          case "digit4":
            this.digit4 = symbol;
            break;
          case "digit5":
            this.digit5 = symbol;
            break;
          case "digit6":
            this.digit6 = symbol;
            break;
          default:
            break;
        }

        $event.preventDefault();
        this.postSmsConfirmationCode();
        $event.target.nextElementSibling.focus();
      }
    },
    postSmsConfirmationCode: function() {
      if (
        this.digit1 !== "" &&
        this.digit2 !== "" &&
        this.digit3 !== "" &&
        this.digit4 !== "" &&
        this.digit5 !== "" &&
        this.digit6 !== ""
      ) {
        const confirmationSmsCode = `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`;
        const fetchTransactionsCriteria = {
          CardGuid: this.cardGuid,
          DateFrom: this.dateFrom,
          DateTo: this.dateTo,
          ConfirmationSmsCode: confirmationSmsCode
        };
        this.$store
          .dispatch(
            actions.POST_SMS_CODE_TO_GET_OLD_TRANSACTIONS_ACCESS_TOKEN,
            fetchTransactionsCriteria
          )
          .then(() => {
            this.closeDisplayPin2Modal();
          });
      }
    },

    getAllTransactions: async function() {
      this.isAllTransactionsGridLoading = true;
      const token = sessionStorage.getItem(
        configuration.apiTransactionsAccessStorageKey
      );
      const fetchTransactionsCriteria = {
        CardGuid: this.cardGuid,
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
        Token: token
      };
      await this.$store.dispatch(
        actions.FETCH_ALL_TRANSACTIONS,
        fetchTransactionsCriteria
      );
    },

    closeDisplayPin2Modal: function() {
      this.requiredSmsCode = false;
      this.isAllTransactionsGridLoading = false;
      this.digit1 = "";
      this.digit2 = "";
      this.digit3 = "";
      this.digit4 = "";
      this.digit5 = "";
      this.digit6 = "";
    }
  },
  watch: {
    requiredSmsCode: function() {
      if (this.requiredSmsCode == true) {
        window.$("#displayPin2").modal("show");
      } else {
        window.$("#displayPin2").modal("hide");
      }
    }
  }
};
</script>
